import React, { useEffect, useState, useContext } from "react";
import './Pqrs.css';
import logo from '../../Assest/LogoSingefin.png';
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import { NavLink } from "react-router-dom";
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";

function PQRS() {

    const urlGetPQRS = urlApiServer + "pqrs?populate=*"
    const urlPostPQRS = urlApiServer + "pqrsforms"

    const [anonymity, setAnonymity] = useState('')
    const [typeofRequest, setTypeofRequest] = useState('')
    const [affair, setAffair] = useState('')
    const [idCard, setIdCard] = useState('')
    const [name, setName] = useState('')
    const [surnames, setSurnames] = useState('')
    const [currentPosition, setCurrentPosition] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [filingDate, setFilingDate] = useState('')
    const [explain, setExplain] = useState('')
    const [data, setData] = useState([]);
    const { infoUser } = useContext(LoginContext)

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }
    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetPQRS, requestOptions)
                    .then(response => response.json())
                    .then(PQRSResponse => {
                        console.log('info del PQRS: ', PQRSResponse.data);
                        setData(PQRSResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();

    }, [urlGetPQRS]);

    function headleAnonymity(e) {

        console.log('Anonimato: ', e.target.value)

        setAnonymity(e.target.value);

    }

    function headleTypeOfRequest(e) {
        console.log('e.target.value: ', e.target.value)
        setTypeofRequest(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleAffair(e) {
        setAffair(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleidCard(e) {
        setIdCard(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleNames(e) {
        setName(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleSurnames(e) {
        setSurnames(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleCurrentPosition(e) {
        setCurrentPosition(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo email, usa `value`
    }

    function headlePhone(e) {
        setPhone(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleFilingDate(e) {
        setFilingDate(e.target.value); // Para un input tipo fecha, usa `value`
    }

    function headleExplain(e) {
        setExplain(e.target.value); // Para un textarea, usa `value`
    }

    async function postFormPQRS() {
        const dataPost = JSON.stringify({
            data: {
                anonimato: anonymity === 'yes' ? true : false,
                tipo_solicitud: typeofRequest,
                asunto: affair,
                cedula: idCard,
                nombres: name,
                apellidos: surnames,
                cargo_actual: currentPosition,
                correo: email,
                celular_contacto: phone,
                fecha_radicacion: filingDate,
                explicar: explain
            }
        });

        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: 'POST',
            headers: registerHeaders,
            body: dataPost,
            redirect: 'follow'
        };

        await fetch(urlPostPQRS, requestOptions)
            .then(response => response.json())
            .then(dataPostResponse => {
                console.log('dataPostResponse', dataPostResponse);
                Swal.fire({
                    title: "Correcto",
                    text: "Haz enviado un pqrs",
                    icon: "success",
                    allowOutsideClick: false
                })
            }).catch(error => {
                Swal.fire({
                    title: "Error",
                    text: "Asegurate de tener todo los datos relleno para enviar tu pqrs",
                    icon: "error",
                    allowOutsideClick: false
                });
            });
    }

    return (
        <div className="containerPQRSSection">
            <div className="containerBannerPQRS">
                <div className="bannerPQRS">
                    <div
                        style={{
                            backgroundImage: data.length > 0 && data[0].imagen_portada_pqrs?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_pqrs.url})`
                                : "url('../../Assest/temporary/bannerPQRS.png')", // Imagen de respaldo
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                        className="imageBannerPQRS"
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerPQRS">
                                {data.length > 0 && data[0].titulo_portada_pqrs ? data[0].titulo_portada_pqrs : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                    {infoUser.isLoged === true ? (
                        <div className="ContainerButton">
                            <div className="ButtonBanner" onClick={loggedInUser}>
                                <p className="titleButtonBanner">VINCULATE</p>
                            </div>
                        </div>
                    ) : (
                        <div className="ContainerButton">
                            <NavLink className="navLinks navLinkLegal" to="/Vinculacion">
                                <div className="ButtonBanner">
                                    <p className="titleButtonBanner">VINCULATE</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div >
            <div className="containerInfoPQRSSection">
                {data.length > 0 && data[0].texto_seccion_pqrs ? (
                    data[0].texto_seccion_pqrs.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoPQRSSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textInfoPQRSSection">
                                                {child.text}
                                            </p>
                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textInfoPQRSSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textInfoPQRSSection">...</p>
                )}
            </div>
            <div className="containerFormPQRSSection">
                <div className="cardFormnPQRSSection">
                    <div className="containerInputsPQRSSection">
                        <select
                            name="anonymity"
                            id="anonymity"
                            value={anonymity}
                            onChange={headleAnonymity}
                            className="inputsPQRSSection"
                        >
                            <option value="anonymity">Quieres anónimato?</option>
                            <option value="yes">Si</option>
                            <option value="no">No</option>

                        </select>
                        <select
                            name="typeOfRequest"
                            id="typeOfRequest"
                            value={typeofRequest}
                            onChange={headleTypeOfRequest}
                            className="inputsPQRSSection"
                        >
                            <option value="typeOfRequest">Tipo de solicitud:</option>
                            <option value="uno">Uno</option>
                            <option value="dos">Dos</option>
                            <option value="tres">Tres</option>
                        </select>
                    </div>
                    <div className="containerInputsPQRSSection">
                        <input
                            type="text"
                            name="affair"
                            placeholder="Asunto"
                            value={affair}
                            onChange={headleAffair}
                            className="inputsPQRSSection"
                        />
                        <input
                            type="number"
                            name="idCard"
                            placeholder="cedula"
                            value={idCard}
                            onChange={headleidCard}
                            className="inputsPQRSSection"
                        />
                    </div>
                    <div className="containerInputsPQRSSection">
                        <input
                            type="text"
                            name="names"
                            placeholder="Nombres"
                            value={name}
                            onChange={headleNames}
                            className="inputsPQRSSection"
                        />
                        <input
                            type="text"
                            name="surnames"
                            placeholder="Apellidos"
                            value={surnames}
                            onChange={headleSurnames}
                            className="inputsPQRSSection"
                        />
                    </div>
                    <div className="containerInputsPQRSSection">
                        <input
                            type="text"
                            name="currentPosition"
                            placeholder="Cargo actual"
                            value={currentPosition}
                            onChange={headleCurrentPosition}
                            className="inputsPQRSSection"
                        />
                    </div>
                    <div className="containerInputsPQRSSection">
                        <input
                            type="email"
                            name="email"
                            placeholder="Correo electronico"
                            value={email}
                            onChange={headleEmail}
                            className="inputsPQRSSection"
                        />
                        <input
                            type="number"
                            name="phone"
                            placeholder="célular de contacto"
                            value={phone}
                            onChange={headlePhone}
                            className="inputsPQRSSection"
                        />
                    </div>
                    <div className="containerInputsEndPQRSSection">
                        <div className="">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Fecha de radicacion
                            </p>
                            <input
                                type="date"
                                name="filingDate"
                                placeholder="Fecha de radicacion"
                                value={filingDate}
                                onChange={headleFilingDate}
                                className="inputsPQRSSection elongatedInputs"
                            />
                        </div>
                        <textarea
                            name="explain"
                            placeholder="Explica de manera puntual:"
                            value={explain}
                            onChange={headleExplain}
                            className="TextareaPQRSSection"
                        />
                    </div>
                    <div className="buttonFormPQRS" onClick={postFormPQRS}>
                        <p className="textFormPQRS">ENVIAR</p>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default PQRS;
